// extracted by mini-css-extract-plugin
export default {"container":"ListCharacteristics_container__l9TyN","gridTable":"ListCharacteristics_gridTable__1bE39","divider":"ListCharacteristics_divider__dFCWw"};